var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventCal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enterprise",
    transform: "translate(-1294.000000, -11605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1294.000000, 11605.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-6",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-calendar-T42UZFVNBG",
    transform: "translate(21.000000, 23.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.875,3.399694 L28.1875,3.399694 L28.1875,0 L24.7706625,0 L24.7706625,3.399694 L21.3543375,3.399694 L21.3543375,0 L17.9375,0 L17.9375,3.399694 L14.5206625,3.399694 L14.5206625,0 L11.103825,0 L11.103825,3.399694 L5.125,3.399694 L0,34 L41,34 L35.875,3.399694 Z M4.033375,30.600306 L8.0196,6.799898 L11.1043375,6.799898 L11.1043375,10.200102 L14.521175,10.200102 L14.521175,6.799898 L17.9375,6.799898 L17.9375,10.200102 L21.3543375,10.200102 L21.3543375,6.799898 L24.7706625,6.799898 L24.7706625,10.200102 L28.1875,10.200102 L28.1875,6.799898 L31.8411125,6.799898 L27.8559125,30.600306 L4.033375,30.600306 Z M34.1432625,13.7410674 L36.9661125,30.600306 L31.3204125,30.600306 L34.1432625,13.7410674 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "24.3998338 17.2501219 25 14 14.4012051 14 13.8010389 17.2501219 19.9318097 17.2501219 12 27 16.4685643 27"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCal);
export default __webpack_public_path__ + "static/media/event-cal.09b1ff643d4d2a8fbef773763e313017.svg";
export { ForwardRef as ReactComponent };